import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { GET } from "../../utils/requests";
import AccountContent from "../account/content";
import AccountSidebar from "../account/sidebar";
import ChatById from "../chat/byid";
import BreadCrumb from "../shared/breadcrumb";
import { NoItemFound } from "../shared/common";
import { MultiLineLoading } from "../shared/loading";
import Home from "./Home";

const AccountLayout = (props) => {
  const router = useRouter();
  const { name } = useSelector((s) => s.auth);

  const {
    children,
    empty = {
      title: "Oops! We didnt get anything",
      body: "Try Adding New Item",
      text: "Let Go",
    },
    url,
    render,
  } = props;

  const [data, setData] = useState();
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (url) Fetch();
    // if (!name)
    //   router.push({
    //     pathname: "/signin",
    //     query: { returnurl: router.asPath },
    //   });
  }, [page, router.query]);

  const Fetch = async () => {
    setData((await GET(url)) || []);
  };

  return (
    <Home title={"Account Layout"} className="bg- pb-5">
      <ChatById />
      <Container className="small-container">
        <BreadCrumb items={[{ label: "Account", href: "/account" }]} />
        <Row className="gx-5">
          <AccountSidebar />
          <AccountContent {...props} router={router}>
            {!data && render ? (
              <MultiLineLoading />
            ) : data?.length === 0 ? (
              <NoItemFound href={{ query: { insert: true } }} {...empty} />
            ) : render ? (
              data.map((s) => (
                <Link href={{ query: { view: s.id, data: JSON.stringify(s) } }}>
                  <div role="button">{render(s)}</div>
                </Link>
              ))
            ) : null}
            {children}
          </AccountContent>
          <div className="text-center">
            {data && render && data?.length > 0 && data?.length % 12 === 0 ? (
              <a
                onClick={() => setPage(page + 1)}
                className="mx-auto fw-600 text-primary"
              >
                Load More
              </a>
            ) : null}
          </div>
        </Row>
      </Container>
    </Home>
  );
};

export default AccountLayout;
